module.exports = __webpack_public_path__ + "img/ycBanner.fafd2f04.png";